// 3-Play Share grants live on the listener's device: { [item_id]: { left, until, share_id } }
const KEY = "wall_share_grants";
const read = () => { try { return JSON.parse(localStorage.getItem(KEY) || "{}"); } catch { return {}; } };
const write = (g) => localStorage.setItem(KEY, JSON.stringify(g));

// The stored entry if it exists and hasn't expired — even when its plays are used up.
export const rawGrant = (itemId) => {
  const g = read()[itemId];
  return g && Date.now() <= g.until ? g : null;
};
export const grantFor = (itemId) => {
  const g = rawGrant(itemId);
  return g && g.left > 0 ? g : null;
};
// One grant per share link per device: reopening the same link never refills; a different friend's link does.
export const addGrant = (itemId, shareId, plays, days) => {
  const g = read();
  const cur = g[itemId];
  if (cur && Date.now() <= cur.until && cur.share_id === shareId) return cur;
  g[itemId] = { left: plays, until: Date.now() + days * 86400000, share_id: shareId };
  write(g);
  return g[itemId];
};
export const consumeGrant = (itemId) => {
  const g = read();
  if (!g[itemId]) return null;
  g[itemId].left = Math.max(0, g[itemId].left - 1);
  write(g);
  return g[itemId];
};
